import { CloseIcon } from "./Icons/CloseIcon";

interface StepperProps {
  current: number;
  total: number;
  closeCallback?: CallableFunction;
  className?: string;
}

const Stepper: React.FunctionComponent<StepperProps> = ({
  current,
  total,
  closeCallback,
  className,
}) => {
  return (
    <div className={`stepper flex gap-4 justify-between items-center ${className}`}>
      <div className="stepper__info">
        {current}/{total}
      </div>
      <div className="stepper-bar">
        <div className="stepper-bar__total"></div>
        <div
          className="stepper-bar__current"
          style={{ width: `${(current / total) * 100}%` }}
        ></div>
      </div>
      <div>
        {closeCallback && (
          <div onClick={() => closeCallback()} className="cursor-pointer">
            <CloseIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default Stepper;

//<div className="break-text" onClick={() => setShowFull(false)}>